import { Store } from "../../@types/contexts/dependentContext/store.types";

const initialState: Store = {
	dependents: []
};

export default initialState;
